import { useLocation, useNavigate } from 'react-router-dom';
import { CheckoutHeader } from '@cencosud-cencommerce/paris-uikit';

import { URL_ROUTES } from '@/constants';
import { useStorageSession } from '@/modules/perseo-billing/hooks/use-storage-session';
import {
  isDeviceAndroid,
  isDeviceIos,
  isDeviceKiosco
} from '@/modules/perseo-billing/utils';
import { SendShippingEvents } from '@/modules/shared/utils/gtmEvents';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendShippingEvents';
import {
  ShippingEventInteractiveActions,
  ShippingEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/types';
import { isWeddingFlow } from '@/modules/shared/utils/isWeddingFlow';
import getStepPage from '@/sections/shared/utils/get-step-page';

import { getCurrentStep } from '.';

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const originURL = typeof window !== 'undefined' ? window.location.origin : '';
  const currentStep = getCurrentStep(location.pathname);
  const isWebView = isDeviceAndroid() || isDeviceIos() || isDeviceKiosco();
  const { user } = useStorageSession();
  const isWedding = isWeddingFlow();

  if (isWebView) return <></>;

  const sendGtmEvent = (index: number) => {
    const steppText: Record<number, string> = {
      1: 'Datos',
      2: 'Entrega',
      3: 'Pago'
    };
    SendShippingEvents.sendEvent({
      event: 'baseEvent',
      extraFields: {
        'event-interactive-tag': steppText[index],
        'event-interactive-accion': ShippingEventInteractiveActions.ClickStepper
      }
    });
  };

  const brand = isWedding ? 'novios-paris' : 'paris';
  const brandLink = isWedding
    ? URL_ROUTES.WEDDING_HOME
    : `${originURL}${URL_ROUTES.HOME}`;

  return (
    <div className="co-px-4 co-bg-white tablet_w:co-px-8 co-py-4 co-border-b co-border-neutral-200">
      <div className="co-mx-auto co-max-w-[1504px]">
        <CheckoutHeader
          variant="stepIndicator"
          brand={{
            link: brandLink,
            name: brand,
            onClick: () =>
              sendEvent({
                event: 'baseEvent',
                extraFields: {
                  'event-interactive-tag': ShippingEventInteractiveTags.Logo
                }
              })
          }}
          stepIndicator={{
            onChange: (index: number) => {
              if (index === 2 && isWedding) return;

              const stepPage = getStepPage(index);
              sendGtmEvent(index);
              navigate(stepPage);
            },
            currentStep: currentStep
          }}
          user={
            user.firstName
              ? {
                  name: user.firstName,
                  onClick: function noRefCheck() {}
                }
              : undefined
          }
        />
      </div>
    </div>
  );
};

export default Header;
